<ng-container *transloco="let t; read: 'configuration'">
<div class="flex justify-between items-center border-b p-4">
  <h1 class="text-[25px] font-bold">
    {{ isEditMode ? t('globalAnnouncements.addEdit.editTitle') : t('globalAnnouncements.addEdit.addTitle') }}
  </h1>
  <i
    class="text-drdpblue-300 cursor-pointer uil uil-times-circle text-2xl"
    (click)="onCancel()"
  ></i>
</div>

<div class="p-4">
  <form
    class="grid md:grid-cols-2 grid-cols-1 gap-4 gap-x-4"
    [formGroup]="form"
  >
      <div class="col-span-2">
        <mat-checkbox
        class="rounded-checkboxes"
        color="primary"
        [checked]="allStates"
        (change)="onAllStatesChange()"
        >
        </mat-checkbox>
        <label class="inline ml-1">{{ t('globalAnnouncements.allStates') }}</label>
      </div>
      <div class="col-span-1" [hidden]="allStates">
          <drdp-select-state
            #stateSelect
            (state)="onStateChange($event)"
            [initialStateId]="announcement.stateId"
            [clear]="clearDropdowns"
            [required]="!allStates"
          ></drdp-select-state>
        </div>
    <div class="col-span-1">
      <label class="font-bold">{{ t('globalAnnouncements.addEdit.warningIcon') }}</label>
      <mat-form-field class="bg-white w-full no-underline" appearance="fill">
        <mat-select formControlName="icon" [placeholder]="t('globalAnnouncements.addEdit.selectIcon')">
          @for (opt of iconOptions; track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <label class="font-bold required">{{ t('common.message') }}</label>
      <mat-form-field class="bg-white w-full" appearance="fill">
        <textarea
          matInput
          formControlName="message"
          rows="4"
          [maxlength]="MESSAGE_MAX"
          [placeholder]="t('globalAnnouncements.addEdit.messagePlaceholder')"
          class="font-bold text-red-600"
        ></textarea>
      </mat-form-field>
      <div class="flex justify-between text-xs">
        @if (isInvalid("message")) {
          <span class="text-red-500">{{
            t('globalAnnouncements.addEdit.messageRequired', { max: MESSAGE_MAX })
          }}</span>
        }
      </div>
    </div>
    <div class="col-span-1">
      <drdp-date-picker
        [label]="t('common.startDate')"
        [required]="true"
        [initialDate]="form.get('startDate')?.value"
        (emitDate)="form.get('startDate')?.setValue($event)"
      ></drdp-date-picker>
      @if (isInvalid("startDate")) {
        <span class="text-red-500 text-xs">{{ t('globalAnnouncements.addEdit.startDateRequired') }}</span>
      }
    </div>
    <div class="col-span-1">
      <drdp-date-picker
        [label]="t('common.endDate')"
        [required]="true"
        [initialDate]="form.get('endDate')?.value"
        (emitDate)="form.get('endDate')?.setValue($event)"
      ></drdp-date-picker>
      @if (isInvalid("endDate")) {
        <span class="text-red-500 text-xs">{{ t('globalAnnouncements.addEdit.endDateRequired') }}</span>
      }
      @if(form.hasError('dateMismatch')) {
        <mat-error>{{ t('common.invalidDateRange') }}</mat-error>
      }
      @if(form.hasError('sameDate')) {
        <mat-error>{{ t('common.sameDateError') }}</mat-error>
      }
    </div>
  </form>
</div>
<div class="flex justify-end p-4 border-t">
  <drdp-btn color="cancel" class="mr-2" (click)="onCancel()">{{ t('common.cancel') }}</drdp-btn>
  <drdp-btn (click)="onSave()" [disabled]="form.invalid">{{ t('common.save') }}</drdp-btn>
</div>
</ng-container>
